import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Visibility } from "@mui/icons-material";
import ACTION_TYPES from "common/utils/actionTypes";
import { Button, ButtonGroup } from "react-bootstrap";

const ActionButtonGroup = ({
  loading,
  handleModalOpen,
  list,
  el,
  editable,
  viewable,
}) => (
  <ButtonGroup>
    {editable ? (
      <Button
        variant="outline-primary"
        disabled={loading}
        onClick={() => handleModalOpen(ACTION_TYPES.EDIT, list, el)}
        size="sm"
      >
        <FontAwesomeIcon icon={faEdit} />
      </Button>
    ) : null}
    {viewable ? (
      <Button
        variant="outline-primary"
        disabled={loading}
        onClick={() => handleModalOpen(ACTION_TYPES.VIEW, list, el)}
        size="sm"
      >
        <Visibility fontSize="small" />
      </Button>
    ) : null}
    <Button
      variant="outline-primary"
      disabled={loading}
      onClick={() => handleModalOpen(ACTION_TYPES.DELETE, list, el)}
      size="sm"
    >
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  </ButtonGroup>
);

export default ActionButtonGroup;
